<template>
    <v-container>
        <page-header :title="`${mode === 'edit' ? 'Edit' : mode === 'show' ? '' : 'New'} League Group`.trim()" icon="mdi-group" />
        <v-card class="form-card" elevation="1">
            <v-form :readonly="readOnly">
                <v-row>
                    <v-col cols="12">
                        <!-- an inactive group (and its leagues) is not shown on the site -->
                        <v-switch
                            v-model="leagueGroup.active"
                            hide-details
                            inset
                            :label="leagueGroup.active ? 'Active' : 'Not Active'"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="leagueGroup.title"
                            outlined
                            dense
                            hide-details="auto"
                            label="Title"
                            type="text"
                            :clearable="clearable"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
        <div v-if="mode !== 'show'" class="form-actions">
            <v-spacer />
            <v-btn large text @click="$router.go(-1)">
                Cancel
            </v-btn>
            <v-btn :loading="loading" :disabled="!leagueGroup.title" class="white--text" large depressed color="black" @click="onSubmit">
                <v-icon left>mdi-content-save-outline</v-icon>Save
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import PageHeader from '@/components/PageHeader'
    import leagueGroupService from '@/services/leagueGroup'
    import Alert from '@/components/Alert'

    export default {
        name: 'LeagueGroupForm',
        components: { Alert, PageHeader },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                leagueGroupId: null,
                leagueGroup: { active: true },
                readOnly: false,
                clearable: true
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.leagueGroupId = this.$route.params.leagueGroupId
            if (this.leagueGroupId) {
                leagueGroupService.getLeagueGroup(this.leagueGroupId).then(resp => {
                    this.leagueGroup = { ...resp.data, active: resp.data.active !== false }
                })
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            onSubmit() {
                this.loading = true
                const request = this.mode === 'edit'
                    ? leagueGroupService.updateLeagueGroup(this.leagueGroupId, this.leagueGroup)
                    : leagueGroupService.createLeagueGroup(this.leagueGroup)
                request.then(() => {
                    this.loading = false
                    this.$router.push('/league-groups')
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            }
        }
    }
</script>
